module.exports = __webpack_public_path__ + "static/media/dynamodb.cd861afa.svg";